module.exports = __webpack_public_path__ + "site/img/22.78a8168d.jpg";